import { render } from "./appMenu.vue?vue&type=template&id=78157e3f&scoped=true&lang=pug"
import script from "./appMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./appMenu.vue?vue&type=script&setup=true&lang=js"

import "./appMenu.vue?vue&type=style&index=0&id=78157e3f&scoped=true&lang=css"

import exportComponent from "/Users/liu/Downloads/开发程序/bridge v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78157e3f"]])

export default __exports__